// extracted by mini-css-extract-plugin
export default {"table":"log__table___7daMM","baseCell":"log__baseCell___9aBy1","cell":"log__cell___j4O1Q log__baseCell___9aBy1","headerCell":"log__headerCell___wxnhw log__baseCell___9aBy1"};